import { atom } from 'jotai';
import { Flex } from 'components/primitives/flex';
import PassengersFilterContent, { PassengersLabel } from './contents/PassengersFilterContent';
import CaptainFilterContent from './contents/CaptainFilterContent';
import {
  checkedCaptainOptionsLabelAtom,
  isAnyFilterActiveAtom,
  isCaptainFilterActiveAtom,
  isCaptainSearchModeAtom,
  isPriceFilterActiveAtom,
  passengersFilterActiveAtom,
  priceAtom,
} from './filterStore';
import CheckboxFilterLabel from './contents/CheckboxFilterLabel';
import OtherFiltersFilterButton from './contents/OtherFiltersFilterButton';
import DurationFilterButton from './contents/DurationFilterButton';
import AtomSlider from './fields/AtomSlider';
import PriceLabel from './contents/PriceFilterContent';

// eslint-disable-next-line import/prefer-default-export
export const getFilterButtons = () => [
  {
    name: 'filters',
    CustomButton: OtherFiltersFilterButton,
    isFilterHiddenAtom: atom(false),
    isFilterActiveAtom: isAnyFilterActiveAtom,
  },
  {
    name: 'duration',
    CustomButton: DurationFilterButton,
    isFilterHiddenAtom: atom(false),
    isFilterActiveAtom: isCaptainFilterActiveAtom,
  },
  {
    name: 'package_type',
    label: (
      <CheckboxFilterLabel
        label="Captain"
        isFilterActiveAtom={isCaptainFilterActiveAtom}
        checkedValuesAtom={checkedCaptainOptionsLabelAtom}
      />
    ),
    content: (
      <Flex maxWidth="244px">
        <CaptainFilterContent />
      </Flex>
    ),
    isFilterActiveAtom: isCaptainFilterActiveAtom,
    isFilterHiddenAtom: isCaptainSearchModeAtom,
  },
  // Removing it based on SRCH-340
  // {
  //   name: 'instant_book',
  //   CustomButton: InstantBookFilterButton,
  //   isFilterHiddenAtom: isCaptainSearchModeAtom,
  // },
  // ...(!smallScreen
  //   ? [
  {
    name: 'passengers',
    label: <PassengersLabel />,
    content: <PassengersFilterContent pb="18px" />,
    isFilterActiveAtom: passengersFilterActiveAtom,
    isFilterHiddenAtom: atom(false),
  },
  {
    name: 'price',
    label: <PriceLabel />,
    isFilterActiveAtom: isPriceFilterActiveAtom,
    isFilterHiddenAtom: atom(false),
    content: <AtomSlider atom={priceAtom} />,
  },
  //   ]
  // : []),
];
